import React, { ChangeEvent, useState } from "react";
import TextField from '@mui/material/TextField';
import { Theme } from "@mui/material/styles";
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Flex } from '../..';

interface TextFieldProps {
    onChange?: any;
    onBlur?: any;
    value?: any;
    placeholder?: string;
    label?: string;
    name?: string;
    tableField?: boolean;
}
// .MuiOutlinedInput-notchedOutline 
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            width: '100%',
            backgroundColor: '#fff',
            '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#00d0e4',
            },
            '& .MuiOutlinedInput-root.Mui-focused': {
                borderColor: '#00d0e4',
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: '#00d0e4',
                },
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#cbd6e2',
            },
            '& > label': {
                color: '#516f90'
            },
            '& label.Mui-focused': {
                color: '#516f90',
            },
        },
    })
);

export const MultiLineTextField = (props: TextFieldProps) => {
    const {
        onChange = () => { },
        onBlur = () => { },
        value,
        placeholder,
        label,
        name,
    } = props;
    const [inputValue, setInputValue] = useState(value);

    const onInputChange = ({ target }: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = target;
        setInputValue(value);
        onChange(name, value);
    };
    const classes = useStyles();
    return (
        <Flex style={{ width: '100%', margin: '0.6rem 0', userSelect: 'none' }}>
            <TextField
                multiline
                variant="outlined"
                onChange={onInputChange}
                onBlur={({ target }) => onBlur(target.name, target.value)}
                name={name}
                value={value}
                className={classes.formControl}
                id="multi-textfield"
                label={label}
                placeholder={placeholder}
            />
        </Flex>
    );
};
